import React, { memo } from 'react'
import './Marketplaces.scss'
import ImageMarquee from '../../../common/components/ImageMarquee'
import { ReactComponent as StubhubLogo } from '../../../assets/logos/partners/stubhub.svg'
import { ReactComponent as TicketmasterLogo } from '../../../assets/logos/partners/ticketmaster.svg'
import { ReactComponent as VividseatsLogo } from '../../../assets/logos/partners/vividseats.svg'
import { ReactComponent as SeatgeekLogo } from '../../../assets/logos/partners/seatgeek.svg'
import { ReactComponent as GametimeLogo } from '../../../assets/logos/partners/gametime.svg'
import { ReactComponent as TickpickLogo } from '../../../assets/logos/partners/tickpick.svg'
import { ReactComponent as GoTicketsLogo } from '../../../assets/logos/partners/gotickets.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import cx from 'classnames'

function Marketplaces({ isMobile }) {
  const images = [
    {
      src: StubhubLogo,
      width: 120,
      name: 'StubHub',
    },
    {
      src: TicketmasterLogo,
      width: 150,
      name: 'TicketMaster',
    },
    {
      src: VividseatsLogo,
      width: 150,
      name: 'VividSeats',
    },
    {
      src: SeatgeekLogo,
      width: 90,
      name: 'SeatGeek',
    },
    {
      src: GametimeLogo,
      width: 150,
      name: 'Gametime',
    },
    {
      src: TickpickLogo,
      width: 150,
      name: 'TickPick',
    },
    {
      src: GoTicketsLogo,
      width: 150,
      height: 'auto',
      name: 'GoTickets',
    },
    {
      src: '/assets/logos/tevo.webp',
      width: 120,
      height: 'auto',
      name: 'TEVO',
    },
    {
      src: '/assets/logos/tn-logo-gray.webp',
      width: 180,
      height: 'auto',
      name: 'TicketNetwork',
    },
  ]

  return (
    <section
      className={cx('marketplaces', {
        mobile: isMobile,
      })}
    >
      <div className="marketplaces-content">
        <div className="marketplaces-announce-wrapper">
          <div className="marketplaces-announce">
            <span className="large">Our partners</span>
            <span className="small">
              If it's Lysted here, it's listed there
            </span>
          </div>
          <FontAwesomeIcon
            size="xs"
            icon={faChevronRight}
            className="chevron-icon"
          />
        </div>
        <div className="marketplaces-partners" style={{ height: 75 }}>
          <ImageMarquee images={images} isMobile={isMobile} />
        </div>
      </div>
    </section>
  )
}

export default memo(Marketplaces)
